import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, EnumDecoder, field, IntegerDecoder } from '@simonbackx/simple-encoding';
export var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "Ascending";
    SortDirection["Descending"] = "Descending";
})(SortDirection || (SortDirection = {}));
// todo: remove?
export class WebshopOrdersQuery extends AutoEncoder {
}
__decorate([
    field({ decoder: IntegerDecoder, optional: true })
], WebshopOrdersQuery.prototype, "afterNumber", void 0);
__decorate([
    field({ decoder: DateDecoder, optional: true })
], WebshopOrdersQuery.prototype, "updatedSince", void 0);
__decorate([
    field({ decoder: new EnumDecoder(SortDirection), optional: true })
], WebshopOrdersQuery.prototype, "sort", void 0);
//# sourceMappingURL=WebshopOrdersQuery.js.map